export const RULE_GRAPH_MAX_ZOOM = 1.4;
